import i18next from 'i18next';
import { useEffect } from 'react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import { statusColor } from '../../utils/statusColors';
import { kezekRequestModule, loadData, clearState } from './KezekRequestDucks';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import './KezekRequestTranslate';
import { useTranslation } from 'react-i18next';
import { kezekRequestColumns } from './KezekRequestColumns';

export default function KezekRequestPage() {
  const { t, i18n } = useTranslation();
  const loading = useSelector(state => state[kezekRequestModule].loadingTable);
  const data = useSelector(state => state[kezekRequestModule].tableData);
  const dispatch = useDispatch();
  const { nextPage } = useTableFilter(filter => dispatch(loadData(filter)));

  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('kezekRequest_title') }
  ];

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3" style={{ minWidth: 2400 }}>
        <div className="flex justify-between items-center">
          <h3>{t('kezekRequest_title')}</h3>
        </div>
        <StaticTablePagination
          columns={kezekRequestColumns({ t, lang: i18n.language })}
          data={data.content}
          sortable={false}
          urlOnClick={row => `/bulletin/${row.original.id}`}
          totalElements={data.totalElements}
          loading={loading}
          onClickLoadMore={() => nextPage()}
          rowBgColor={row => statusColor[row.original.resolutionType]}
        />
      </Paper>
    </>
  );
}
